import {
  Button,
  Flex,
  Menu,
  type ButtonProps,
  AddRoundedIcon,
  ExpandMoreRoundedIcon,
  MenuItem,
  Text,
  Box,
  Tooltip,
  type TooltipProps,
} from '@shared/components';
import { useState } from 'react';

interface MenuButtonProps extends ButtonProps {
  options: {
    label: string;
    onClick: () => void;
    disabled?: boolean;
    slotProps?: {
      tooltip?: Omit<TooltipProps, 'children'>;
    };
  }[];
}

export default function MenuButton(props: Readonly<MenuButtonProps>) {
  const { options, ...buttonProps } = props;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const handleOpenMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        {...buttonProps}
        onClick={handleOpenMenu}
        startIcon={<AddRoundedIcon />}
        endIcon={<ExpandMoreRoundedIcon />}
      />
      <Menu
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleCloseMenu}
        sx={(theme) => ({
          ' .MuiList-root': {
            p: theme.spacing(0),
          },
          '.MuiPaper-root': {
            borderRadius: theme.shape.rounded(2),
            mt: theme.spacing(1),
          },
        })}
      >
        <Flex
          sx={{
            flexDirection: 'column',
            width: '168px',
          }}
        >
          {options.map((option) => (
            <Tooltip
              title={option.slotProps?.tooltip?.title}
              {...option.slotProps?.tooltip}
              key={`${option.label}-tooltip`}
            >
              {/* REMARK: NOTE: This Box is necessary for triggering tooltip display with a disabled element since tooltip doesn't support disabled element */}
              <Box>
                <MenuItem
                  key={option.label}
                  sx={(theme) => ({ p: theme.spacing(2, 3.5) })}
                  onClick={option.onClick}
                  disabled={option.disabled}
                >
                  <Text variant='body2Semibold'>{option.label}</Text>
                </MenuItem>
              </Box>
            </Tooltip>
          ))}
        </Flex>
      </Menu>
    </>
  );
}
